/**
 * Start a dynamic import for its side effect of warming the chunk cache.
 *
 * Prefetching is best-effort: a transient network failure on hover must not
 * surface as an `unhandledrejection` (and Sentry noise), because the render path
 * will retry the same import when the user actually navigates. Rejections are
 * therefore swallowed here — never use this where the caller needs the module.
 *
 * Keep the `import()` itself in the *calling* module's top-level scope. An
 * `import()` written inside a component body makes the React Compiler bail out
 * of that whole component (`BuildHIR::lowerExpression`), costing the automatic
 * memoization that the prefetch was meant to complement.
 */
export function warmChunk(load: () => Promise<unknown>): void {
  load().catch(() => {});
}
